import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import LeftSidebar from "../../components/LeftSidebar/LeftSidebar";
import {Layout} from "antd";
import '../../../../../assets/scss/theme/admin/style.scss';

export const ErrorLayout: React.FC = () => {
    return (
        <Layout id={"admin-theme-wrapper"} className="app-wrapper admin-theme-wrapper">
            <Header />
            <Layout className="error-layout">
                <LeftSidebar />
                <Layout.Content className="content-wrapper">
                    <div className="main-content">
                        <h3>This is Error Layout</h3>
                        <Outlet />
                    </div>
                </Layout.Content>
            </Layout>
            <Footer />
        </Layout>
    )
}